"use client";

import { JsonLd } from "@/components/common/structured-data/json-ld";
import { profileDetailsEntity } from "@/components/common/structured-data/profile-entity";

// `ProfilePage` tylko na stronie samego autora — na innych stronach Google uznałby ją za fałszywą stronę profilu.
export const AuthorStructuredData = ({
  author,
}: {
  author: ProfileVM & Partial<Pick<AuthorVM, "publicationCount">>;
}) => {
  const entity = profileDetailsEntity(author);

  return (
    <JsonLd
      data={{
        "@type": "ProfilePage",
        url: entity.url,
        mainEntity: {
          ...entity,
          agentInteractionStatistic: author.publicationCount
            ? {
                "@type": "InteractionCounter",
                interactionType: "https://schema.org/WriteAction",
                userInteractionCount: author.publicationCount,
              }
            : undefined,
        },
      }}
    />
  );
};
